module.exports = __webpack_public_path__ + "img/SPbFKS-bg.33e09f53.jpg";